// extracted by mini-css-extract-plugin
export default {"Part4":"part4_Part4__v9bFj","flex":"part4_flex__7yyq8","right":"part4_right__hbkLG","text":"part4_text__IfPjE"};